import type { MigrationManifest } from 'redux-persist';

export const PERSIST_VERSION = 1;

/**
 * Keyed by target version, consumed by `createMigrate` on the root persistor (which now
 * whitelists `preferences`/`cookieConsent`; `auth` and `impersonation` have their own nested
 * persistors — see `store.ts`). Add `[version]: (state) => nextState` here when a persisted
 * slice's shape changes; never mutate a migration already shipped, only append new ones.
 */
export const migrations: MigrationManifest = {};
